/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Passkey_Required_For_Platform_PlanInputs */

const es_co2_error_passkey_required_for_platform_plan = /** @type {(inputs: Error_Passkey_Required_For_Platform_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este plan requiere una llave de plataforma activa.`)
};

/**

* @param {Error_Passkey_Required_For_Platform_PlanInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const error_passkey_required_for_platform_plan = /** @type {((inputs?: Error_Passkey_Required_For_Platform_PlanInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Passkey_Required_For_Platform_PlanInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_error_passkey_required_for_platform_plan(inputs)
});